import { z } from 'zod'

import { useFormWithZod } from '@/hooks/useFormWithZod'

const schema = () =>
  z.object({
    levels: z.array(
      z.object({
        threshold: z
          .string({ required_error: 'Threshold is required' })
          .min(1, 'Threshold is required')
          .or(z.number()),
        label: z
          .string({ required_error: 'Label is required' })
          .min(1, 'Label is required'),
        color: z
          .string({ required_error: 'Color is required' })
          .min(1, 'Color is required'),
      })
    ),
  })

export type LevelsModel = z.infer<ReturnType<typeof schema>>

export const useLevelsForm = () => {
  const levelsFormTypeSchema = schema()
  const { form, rule } = useFormWithZod(levelsFormTypeSchema)
  return { form, rule, schema: levelsFormTypeSchema }
}
